const shopperLocale = (language?: string): string => language?.startsWith('fr') ? 'fr-CA' : 'en-CA';

export const formatMissionDate = (date: Date, language?: string): string =>
  new Intl.DateTimeFormat(shopperLocale(language), { year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);

export const formatMissionDateTime = (date: Date, language?: string): string =>
  new Intl.DateTimeFormat(shopperLocale(language), {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
  }).format(date);
